export const fmtMoney = (n) => `R${Number(n || 0).toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const PAYMENT_STATUS_TONE = {
  "Draft": "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-500/15 dark:text-slate-300 dark:border-slate-500/25",
  "Sent": "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-500/15 dark:text-blue-300 dark:border-blue-500/25",
  "Paid": "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-500/15 dark:text-emerald-300 dark:border-emerald-500/25",
  "Partially Paid": "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-500/15 dark:text-amber-300 dark:border-amber-500/25",
  "Overdue": "bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-500/15 dark:text-rose-300 dark:border-rose-500/25",
};

export const REMINDER_STATUS_TONE = {
  "Pending Approval": "bg-amber-50 text-amber-700 border-amber-200",
  "Approved": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Sent": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Cancelled": "bg-slate-100 text-slate-500 border-slate-200",
};
